export const initialState = {
    agendaList: [],
    agendaDetails: null,
    meetingTypeFilterWidth: 0,
    agendaSelectedTab: 0,
    durationFilter: {},
    agendaListByMeetingType: [],
    agendaListWithArchive: [],
    meetingsByAgenda: [],
    newMeetingsByAgenda: [],
    agendaMeetingChatLists: [],
    agendaMeetingChatParticipants: [],
    observerList: [],
    e_signature_provider: [],
    meetingChatComments: null,
    firstMonthOfYear: 0,
    activeAgendaUITab: 0,
    lcaData: [],
    consolidatedLcaData: [],
    lcaCompanies: [],
    lcaFiscalTerms: [],
    currentLCATab: 0,
};

const state = { ...initialState };

export default state;